module.exports = __webpack_public_path__ + "static/media/photo92.4f119f60.jpg";